// removed by extract-text-webpack-plugin
module.exports = {"ad-img-bckgrnd":"ad-img-bckgrnd___3yNGl center___2iqBf","ad-cntr":"ad-cntr___3T4cA center___2iqBf space-top-12___3DU92 space-bottom-12___rGCm0","ad-icn":"ad-icn___20f3S","ad-cpy":"ad-cpy___1Sc3n","ad-hl":"ad-hl___1jHMa h2___hzLuT","ad-p":"ad-p___idXw8 space-top-2___3NWCg h5___l1yk7","wht":"wht___3NSDh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppDisclaimer/AppDisclaimer.css
// module id = 877
// module chunks = 0